type FeeLike = Record<string, unknown> & { feeType?: unknown };

function findSpecificFeeData(feeType: unknown, data?: FeeLike[]): FeeLike {
    return data?.find((item) => item.feeType === feeType) || {};
}

export default findSpecificFeeData;
